import http, { url } from '../../http'

const API_URL = "ocupational_medical_danger"

class OrderMedicineAPI {

  async save(ocupational_medical_danger) {
    const response = await http(`${API_URL}/save`, 'POST', ocupational_medical_danger)
    return response
  }

  async getAllOrder() {
    const response = await http(`${API_URL}`)
    return response
  } 
 
  async getOrder(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async updateOrder(id, medicina) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', medicina)
    return response
  }
 
  async deleteOrder(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  async getOrderByID(id, page, search) {
    const response = await http(`${API_URL}/ocupational/${id}?page=${page}&search=${search}` , 'POST')
    return response
  }

  async getOrderBy(id) {
    const response = await http(`${API_URL}/ocupational/${id}` , 'POST')
    return response
  }


  
}

export default new OrderMedicineAPI()